<template lang="html">
  <v-text-field
    ref="input"
    v-bind="$attrs"
    :suffix="cents ? '' : '.00'"
    :value="formattedValue"
    :label="internalLabel"
    data-lpignore="true"
    type="tel"
    :persistent-hint="messages.length > 0"
    class="si-input-number hide-spinner"
    :rules="evaluatedRules"
    @click:append="confirmValue"
    @input="handleInput"
    @change="handleChange"
    @keydown="keyDown"
    @click="inputClicked"
  />
  <!-- @focus="prefix = '$'"
  @blur="prefix = ''"
  :prefix="formattedValue === '' ? prefix : ''" -->
</template>

<script>
import { clone } from 'lodash'
import element from '@/mixins/element'

export default {
  mixins: [ element ],
  props: {
    value: {
      // type: [Number, String, null],
      default: ''
    },
    cents: {
      type: Boolean
    }
  },
  data () {
    return {
      // askDecimal: this.cents,
      // messages: [],
      prefix: '',
      lazyValue: this.value,
      formattedValue: '',
      requiredRule: v => { return this.valueValid(v) || `${this.$attrs.label || 'This field'} is required` }
    }
  },
  computed: {
    currencyOptions () {
      var options = Object.assign({}, defaults)
      options.precision = this.cents ? 2 : 0
      return options
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.lazyValue = newValue
        var formatted = notZero(newValue) ? '' : format(newValue / 100, this.currencyOptions, true)
        if (formatted !== this.formattedValue) {
          if (this.isUpdating) return
          this.formattedValue = formatted
        }
      }
    }
  },
  mounted () {
    if (!this.$refs.input) return
    var ref = this.$refs.input
    var el = ref.$el.getElementsByTagName('input')[0]
    var opt = this.currencyOptions

    el.oninput = () => {
      let value = el.value
      let positionFromEnd = el.value.length - el.selectionEnd

      if (!this.cents && value.indexOf(opt.decimal) > -1) {
        value = value.split(opt.decimal)[0]
      }

      el.value = format(value, opt, true) // Added this in to remove decimals from the input when dollars only
      this.formattedValue = format(value, opt, true)
      this.$nextTick(() => {
        // if (e.inputType === 'insertFromPaste') this.onPaste() // remove this to take out warning
        positionFromEnd = Math.max(positionFromEnd, opt.suffix.length) // right
        positionFromEnd = el.value.length - positionFromEnd
        positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1) // left
        setCursor(el, positionFromEnd)
      })
    }

    el.onfocus = () => {
      if (this.formattedValue === '') {
        // var defaultVal = format(0, opt, true)

        // this.formattedValue = defaultVal
        this.formattedValue = opt.prefix

        this.$nextTick(() => {
          // el.setSelectionRange(0, opt.prefix.length)
          el.setSelectionRange(opt.prefix.length, opt.prefix.length)
        })
      } else {
        el.setSelectionRange(0, el.value.length)
      }
      // ref.resetValidation()
    }

    el.onblur = () => {
      if (this.formattedValue === opt.prefix) {
        this.formattedValue = ''
        this.lazyValue = ''
      }
      // remove here down to take out warning
      // if (this.askDecimal && this.formattedValue) {
      //   this.messages = ['You did not enter any cents, is this value correct?']
      // }
      this.askDecimal = this.cents
    }

    el.onpaste = (e) => {
      e.stopPropagation();
      e.preventDefault();
      let clipboardData = e.clipboardData || window.clipboardData;
      let value = clipboardData.getData('Text');
      
      if (!this.cents && value.indexOf(opt.decimal) > -1) {
        value = value.split(opt.decimal)[0]
      }

      this.formattedValue = format(value, opt, true)
        this.emit('input', format(value, opt, true))
      this.$nextTick(() => {
      })
      // setTimeout(() => {
      //   if (this.formattedValue !== el.value) el.value = this.formattedValue
      // })
    }
  },
  methods: {
    confirmValue () {
      // remove here down to take out warning
      // this.messages = []
    },
    onPaste () {
      // remove here down to take out warning
      // this.$nextTick(() => {
      //   if (!this.formattedValue) return
      //   if (this.formattedValue.split('.').length > 1) this.askDecimal = false
      // })
    },
    keyDown (e) {
      // remove here down to take out warning
      // if (e.key === '.') this.askDecimal = false
      // NOTE: I re-enabled keydown emit. Remove if currency input plays up
      this.$emit('keydown', e)
    },
    handleChange (v) {
      this.emit('change', v)
    },
    handleInput (v) {
      this.emit('input', v)
    },
    emit (evt, v) {
      var value = notZero(v) ? '' : clone(wholeCents(unformat(v, this.currencyOptions) * 100))
      this.isUpdating = true
      this.lazyValue = value
      this.$emit(evt, value)
      this.$nextTick(() => {
        this.isUpdating = false
      })
    },
    inputClicked () {
      var { prefix } = this.currencyOptions

      if (this.formattedValue === prefix) {
        var el = this.$refs.input.$el.getElementsByTagName('input')[0]
        el.setSelectionRange(prefix.length, prefix.length)
        this.$nextTick(() => {
        })
      }
    }
  }
}

const defaults = {
  prefix: '$',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 2
}

function notZero (value) {
  return ['', undefined, null].includes(value)
}

function format (value, opt, allowZero) {
  opt = Object.assign({}, defaults, opt)
  if (notZero(value)) return ''
  if (value === 0 && !allowZero) return ''
  if (typeof value === 'number') {
    value = value.toFixed(fixed(opt.precision))
  }
  value = toStr(value)
  var negative = value.indexOf('-') >= 0 ? '-' : ''
  var numbers = onlyNumbers(value)
  var currency = numbersToCurrency(numbers, opt.precision)
  var parts = toStr(currency).split('.')
  var integer = parts[0]
  var decimal = parts[1]
  integer = addThousandSeparator(integer, opt.thousands)
  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix
}

function unformat (value, opt) {
  opt = Object.assign({}, defaults, opt)
  if (!value && value !== 0) return ''
  value = toStr(value)
  var precision = opt.precision
  var negative = value.indexOf('-') >= 0 ? -1 : 1
  var numbers = onlyNumbers(value)
  var currency = numbersToCurrency(numbers, precision)
  return parseFloat(currency) * negative
}

function onlyNumbers (value) {
  return toStr(value).replace(/\D+/g, '') || 0
}

// function onlyNumbersWithDecimal (value) {
//   return toStr(value).replace(/[^0-9.]/g, '')
// }

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed (precision) {
  return between(0, precision, 20)
}

function between (min, n, max) {
  return Math.max(min, Math.min(n, max))
}

function numbersToCurrency (numbers, precision) {
  var exp = Math.pow(10, precision)
  var float = parseFloat(numbers) / exp
  return float.toFixed(fixed(precision))
}

function addThousandSeparator (integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
}

// function currencyToIntegerAndDecimal (float) {
//   return toStr(float).split('.')
// }

function joinIntegerAndDecimal (integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer
}

function toStr (value) {
  return value ? value.toString() : ''
}

function setCursor (el, position) {
  var setSelectionRange = function () { el.setSelectionRange(position, position) }
  if (el === document.activeElement) {
    setSelectionRange()
    setTimeout(setSelectionRange, 1) // Android Fix
  }
}

// function toFixedExact (value, opt) {
//   opt = Object.assign({}, defaults, opt)
//   if (!value && value !== 0) return
//   var precision = opt.precision
//   // var reg = new RegExp('^-?\\d+(?:\.\\d{0,' + (precision || -1) + '})?')
//   var reg = new RegExp('^-?\\d+(?:.\\d{0,' + (precision || -1) + '})?')
//   return Number(value.toString().match(reg)[0])
// }

// function dollarsToCents (value) {
//   // if (typeof value !== 'string' && typeof value !== 'number') {
//   //   throw new Error('Value passed must be of type String or Number.')
//   // }
//   return Math.round(100 * parseFloat(typeof value === 'string' ? value.replace(/[$,]/g, '') : value))
// }
// function centsToDollars (value, opt = defaults) {
//   // if (typeof value !== 'string' && typeof value !== 'number') {
//   //   throw new Error('Value passed must be of type String or Number.')
//   // }
//   // if (!value && value !== 0) return ''
//   // return (value/100).toFixed(opt.precision)
//   return toFixedExact(value / 100, opt)
// }

function wholeCents (value) {
  if (!value && value !== 0) return
  return Math.round(parseFloat(value))
}

</script>

<style lang="css">
</style>
